import API from "./api";

// GET ALL JOBS (UPDATED WITH PAGINATION)
export const getJobs = async (params = {}) => {
  try {
    const response = await API.get("/jobs", { params });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching jobs:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// GET JOB BY ID  (ADDED TO FIX ERROR)
export const getJobById = async (id) => {
  try {
    const response = await API.get(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching job by id:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// CREATE JOB
export const createJob = async (jobData) => {
  try {
    const response = await API.post("/jobs/create", jobData);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching job by id:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// UPDATE JOB
export const updateJob = async (id, jobData) => {
  try {
    const response = await API.put(`/jobs/${id}/update`, jobData);
    return response.data;
  } catch (error) {
    console.error("Error updating job:", error.response?.data || error.message);
    throw error;
  }
};

// DELETE JOB
export const deleteJob = async (id) => {
  try {
    const response = await API.delete(`/jobs/${id}/delete`);
    return response.data;
  } catch (error) {
    console.error("Error deleting job:", error.response?.data || error.message);
    throw error;
  }
};

// SEND REFERRAL EMAILS
export const sendReferralEmails = async (jobId) => {
  try {
    const response = await API.post("/referral/send-referrals", null, {
      params: { jobId },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error sending referral emails:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getApplications = async (params = {}) => {
  try {
    const response = await API.get("/applications/all", { params });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching applications:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const updateApplicationStatus = async (applicationId, status) => {
  try {
    const response = await API.put(`/applications/${applicationId}/status`, {
      status,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error updating status:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const scheduleInterview = async (applicationId, data) => {
  try {
    const response = await API.post(
      `/applications/${applicationId}/schedule-interview`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error scheduling interview:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getScheduledInterviews = async () => {
  try {
    const response = await API.get(
      "/applications/filter?status=INTERVIEW_SCHEDULED",
    );

    console.log("Scheduled Interviews:", response.data);

    return response.data.data;
  } catch (error) {
    console.error(
      "Error fetching interviews:",
      error.response?.data || error.message,
    );

    throw error;
  }
};

export const getInterviewScheduledApplications = async () => {
  try {
    const response = await API.get(
      "/applications/filter?status=INTERVIEW_SCHEDULED",
    );
    return response.data.data;
  } catch (error) {
    console.error(
      "Error fetching scheduled interviews:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
